import { AppDispatch } from 'redux/store';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore

import axios, { AxiosResponse } from 'axios';
import { logoutHandler } from 'global/helperFunctions/logoutHnadler';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { RefreshTokenResponseType } from 'global/Models/userModel';
import { BASE_URL } from './ApiService';

let loading = false;

export const handleRefreshToken = (refreshToken: string, token: string) => async (dispatch: AppDispatch) => {
  if (!refreshToken || !token) {
    loading = false;
    return logoutHandler(dispatch);
  }

  if (loading) return;
  loading = true;
  await axios
    .post(
      // BASE_URL + 'v2/Users/RefreshToken',
      BASE_URL + 'v2/Users/RefreshTokenWithRole',
      { refreshToken, token: token.replace('bearer ', '') }
    )
    .then((res: AxiosResponse<IBackendGetGeneric<RefreshTokenResponseType>>) => {
      loading = false;
      const response = res.data;
      if (response.isSuccess) {
        localStorage.setItem('roles', JSON.stringify(response.data.roles));
        localStorage.setItem('sessionid', `${response.data.token_type} ${response.data.access_token}`);
        localStorage.setItem('tokenExpiresAt', Date.now() + response.data.expires_in * 1000 + '');
        localStorage.setItem('refreshToken', response.data.refresh_token);
        window.location.reload();
      } else {
        loading = false;
        logoutHandler(dispatch);
      }
    })
    .catch(() => {
      loading = false;
      logoutHandler(dispatch);
    });
};
